import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledDataInvolvedItem = styled.div`
  border-bottom: ${({ isInList }) => (isInList ? '1px dashed #ddd' : 'none')};
  margin: ${({ isInList }) => (isInList ? '16px 0' : 0)};
  padding-bottom: ${({ isInList }) => (isInList ? '12px' : 0)};
`;
